import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SettingsService } from '@proxy/administration-service/settings';
import {
  AssetActionModalType,
  AssetDetailsDto,
  AssetTransferableParts,
} from '@proxy/register-service/assets';
import { TenancyService } from '@proxy/administration-service/tenancy';
import { QueueItemDto } from '@proxy/queue-service';

@Component({
  selector: 'app-queue-modals',
  templateUrl: './queue-modals.component.html',
  styleUrls: ['./queue-modals.component.scss'],
})
export class QueueModalsComponent implements OnInit {
  @Input() asset: AssetDetailsDto | null = null;
  @Input() selectedAssets: QueueItemDto[] = [];
  @Input() isModalOpen: boolean = false;
  @Input() showMessage = false;
  @Input() pinOrKeyringPassword: string = '';
  @Input() selectedIds: string[] = [];
  @Input() type: AssetActionModalType | null = null;
  @Input() isGuest: boolean = false;
  @Output() modalClose = new EventEmitter<boolean>();

  twoStepEnabled = false;
  showTransferModal: boolean = false;
  transferData: AssetTransferableParts = {};

  AssetActionModalType = AssetActionModalType;
  constructor(
    public readonly service: SettingsService,
    private tenancyService: TenancyService,
  ) {}

  ngOnInit(): void {
    if (this.asset) {
      this.tenancyService.getTwoStepStatus(this.asset.id).subscribe({
        next: data => {
          this.twoStepEnabled = data || this.asset?.isParent || this.asset?.hasSubAssets || false;
        },
      });
    }
  }

  triggerTransferAction(data: AssetTransferableParts) {
    this.transferData = data;
  }

  closeModal(isApplied: boolean) {
    this.modalClose.emit(isApplied);
  }
}
